import {useContext, useEffect, useState} from "react";
import "../../styles/css/admin-style.css"
import {authService} from "../../services/authService";
import {useNavigate, useLocation} from "react-router-dom";
import {AuthenticationHandler} from "../auth/AuthenticationHandler";
import EditOwnProfileModal from "../EditOwnProfileModal";
import eventEmitter from "../../shared/eventEmitter";
import {Accordion, Button, Nav} from "react-bootstrap";
import {EventEmitterTypes} from "../../shared/eventEmitterEnum";
import notificationService from "../../services/NotificationService";
import {businessYearService} from "../../services/businessYearService";

const AdminSideNav: React.FC = () => {
    const auth = useContext(AuthenticationHandler);
    const [email, setEmail] = useState("")
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userId, setUserId] = useState("")
    const [estimateTotal, setEstimateTotal] = useState(0)
    const [loading, setIsLoading] = useState(false)
    const location = useLocation();
    useEffect(() => {
        refreshData();

        const refreshListener = () => refreshData();

        eventEmitter.on(EventEmitterTypes.REFRESH_INFO, refreshListener);

        return () => {
            eventEmitter.off(EventEmitterTypes.REFRESH_INFO, refreshListener);
        };
    }, []);

    const refreshData = () => {
        Promise.resolve(
            auth.getInfo()
        ).then(postRes => {
            if(!postRes) {
                //logout. info could not be found
                navigate('/admin-login')
            }
            setEstimateTotal(postRes.incompleteEstimate)
            setUserId(postRes.userId)
            setFirstName(postRes.firstName)
            setLastName(postRes.lastName)
            setEmail(postRes.email)
            eventEmitter.emit(EventEmitterTypes.REFRESH_USERS)
            setIsLoading(false)
            return postRes;
        });
    }

    const isActive = (keyword) => location.pathname.includes(keyword);

    const getInitials = (firstName, lastName) => {
        const firstInitial = firstName ? firstName.trim().charAt(0).toUpperCase() : '';
        const lastInitial = lastName ? lastName.trim().charAt(0).toUpperCase() : '';
        return `${firstInitial}${lastInitial}`;
    };

    const [isModalVisible, setIsModalVisible] = useState(false);
    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    }
    const navigate = useNavigate();
    return (
        <>
            <div id="admin-menu">
                <div className="logo">
                    <a href="" className="border-0"><img src="/logo/logoBigger.svg"
                                                         alt="Barreca Logo"/></a>
                </div>
                <div className="user-welcome">
                    <div className="me-2">
                        <div className="avatar avatar-md">{getInitials(firstName, lastName)}</div>
                    </div>
                    <div>
                        <p className="mb-2 text-strong">{`${firstName} ${lastName}`}</p>
                        <div className="d-flex align-items-center">
                            <Button variant="link" onClick={toggleModal} className="small p-0">
                                <i className="fa-light fa-pencil"></i> Profile
                            </Button>
                            <i className="fa-light fa-pipe mx-2 text-muted"></i>
                            <Button
                                variant="link"
                                onClick={() => {
                                    auth.logout();
                                    navigate('/admin-login');
                                }}
                                className="small p-0"
                            >
                                <i className="fa-light fa-sign-out"></i> Logout
                            </Button>
                        </div>
                    </div>
                </div>

                <Accordion defaultActiveKey={['0', '1', '2', '3', '4', '5', '6', '7']} className="site-nav" alwaysOpen flush>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                              <span className="menuIcon">
                                <i className="fa-regular fa-users"></i>
                              </span>{' '}
                              Users
                        </Accordion.Header>
                        <Accordion.Body className={isActive('admin/management') ? 'activePage' : ''}>
                            <div className="flex-column">
                                <div style={{cursor: "pointer",}} onClick={() => navigate('/admin/management')}>
                                  <span className="menuIcon">
                                    <i className="fa-regular fa-user-shield"></i>
                                  </span>{' '}
                                    Admins
                                </div>
                            </div>
                        </Accordion.Body>
                        <Accordion.Body className={isActive('admin/customer') ? 'activePage' : isActive('admin/job') ? 'activePage' : ''}>
                            <div className="flex-column">
                                <div style={{cursor: "pointer",}} onClick={() => navigate('/admin/customers')}>
                                  <span className="menuIcon">
                                    <i className="fa-regular fa-users"></i>
                                  </span>{' '}
                                    Customers
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                    {auth.isSuperAdmin && <Accordion.Item eventKey="2">
                        <Accordion.Body
                            className={isActive('admin/yearly-settings') ? 'header-style activePage' : 'header-style'}
                            onClick={() => navigate('/admin/yearly-settings')}
                            style={{cursor: "pointer",}}
                        >
                            <span className="menuIcon">
                              <i className="fa-light fa-calendar"></i>
                            </span>
                            Yearly Settings
                        </Accordion.Body>
                    </Accordion.Item>}
                    <Accordion.Item eventKey="3">
                        <Accordion.Body
                            className={isActive('admin/estimate') ? 'header-style activePage' : 'header-style'}
                            onClick={() => navigate('/admin/estimates')}
                            style={{cursor: "pointer",}}
                        >
                            <span className="menuIcon">
                              <i className="fa-light fa-file-invoice"/>
                            </span>
                            Estimates
                            {estimateTotal > 0 && <span className="d-inline-block ms-2">
                                <span className="menuCounter ohSnap">{estimateTotal}</span>
                            </span>}
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Body
                            className={isActive('admin/reports') ? 'header-style activePage' : 'header-style'}
                            onClick={() => navigate('/admin/reports')}
                            style={{cursor: "pointer",}}
                        >
                            <span className="menuIcon">
                              <i className="fa-light fa-file-export"/>
                            </span>
                            Reports
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                        <Accordion.Body
                            className={isActive('admin/scheduled-jobs') ? 'header-style activePage' : 'header-style'}
                            onClick={() => navigate('/admin/scheduled-jobs')}
                            style={{cursor: "pointer",}}
                        >
                            <span className="menuIcon">
                              <i className="fa-light fa-calendar-day"/>
                            </span>
                            Scheduled Jobs
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6">
                        <Accordion.Body
                            className={isActive('admin/web-not-run') ? 'header-style activePage' : 'header-style'}
                            onClick={() => navigate('/admin/web-not-run')}
                            style={{cursor: "pointer",}}
                        >
                            <span className="menuIcon">
                              <i className="fa-light fa-credit-card"/>
                            </span>
                            Web Not Run
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="6">
                        <Accordion.Body
                            className={isActive('admin/deposit-slips') ? 'header-style activePage' : 'header-style'}
                            onClick={() => navigate('/admin/deposit-slips')}
                            style={{cursor: "pointer",}}
                        >
                            <span className="menuIcon">
                              <i className="fa-light fa-money-simple-from-bracket"/>
                            </span>
                            Deposit Slips
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>

    <EditOwnProfileModal
                show={isModalVisible}
                toggle={toggleModal}
                user={{ firstName, lastName, email, userId }}
                refreshData={refreshData}
            />
        </>
    );
};

export default AdminSideNav;
